import { HasChildren } from '@eppendorf/vnls-react-components';
import { ReactElement } from 'react';

import {
  isEssentialsPlan,
  isSampleSafetyPlusPlan,
  useGetSubscription,
} from '$features/subscription/subscription-api';

export function SampleSafetyPlusOnly({ children }: HasChildren): ReactElement | null {
  const { data: subscription, isLoading } = useGetSubscription();

  if (isLoading || !isSampleSafetyPlusPlan(subscription)) {
    return null;
  }

  return children as ReactElement;
}

export function EssentialsOnly({ children }: HasChildren): ReactElement | null {
  const { data: subscription, isLoading } = useGetSubscription();

  if (isLoading || !isEssentialsPlan(subscription)) {
    return null;
  }

  return children as ReactElement;
}
